import {useContext} from "react";
import {MyContext} from "../context/myContext";

const AddUserBox = ({formComponent: FormComponent}) => {
    const {handleShowForm, formTitle, showForm, showEditForm} = useContext(MyContext)
    return(
        <div className={`${(showForm || showEditForm) && 'top-[5%]'} w-[90vw] sm:w-[80vw] md:w-[70vw] lg:w-[50vw] popup-styles`}>
            <div className='flex justify-between items-center px-1 py-3 border-b border-b-borderColor'>
                <i className="fa fa-times close-icon text-lg text-gray-600 cursor-pointer hover:text-gray-900" onClick={handleShowForm}></i>
                <p dir='rtl' className='text-base sm:text-lg'>{formTitle}</p>
            </div>
            <FormComponent />
        </div>
    )
}

export default AddUserBox